"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoles = exports.BROADCASTS = exports.QUEUES = exports.MILESTONES_GROUP = exports.SCHEDULE_AND_RCP_MILESTONES = exports.RCP_MILESTONES = exports.SCHEDULE_MILESTONES = exports.MILESTONES = exports.CORE_QUEUES = void 0;
exports.CORE_QUEUES = {
    ATTENDANCES: 'core.attendances',
    INTERNAL_ATTENDANCES: 'core.internal.attendances',
    AVAILABILITY_BLOCKS: 'core.availability-blocks',
    AVAILABILITY_TYPES: 'core.availability-types',
    CITIES: 'core.cities',
    COMPANIES: 'core.companies',
    EMPLOYEE_TERMS: 'core.employee-terms',
    EMPLOYEES: 'core.employees',
    EVENTS: 'core.events',
    HISTORY: 'core.history',
    INTERNAL_EMPLOYEES: 'core.internal.employees',
    INTERNAL_JOB_TITLES: 'core.internal.job-titles',
    INTERNAL_LOCATIONS: 'core.internal.locations',
    INTERNAL_SCHEDULE_SHIFTS: 'core.internal.schedule-shifts',
    INTERNAL_USERS: 'core.internal.users',
    JOB_TITLES: 'core.job-titles',
    LABELS: 'core.labels',
    LOCATIONS: 'core.locations',
    NOTIFICATIONS: 'core.notifications',
    OPEN_SHIFTS: 'core.open-shifts',
    PRODUCTION_QUOTAS: 'core.production_quotas',
    RCP: 'core.rcp',
    REPORTS: 'core.reports',
    SCHEDULE_SHIFTS: 'core.schedule-shifts',
    SHIFTBLOCKS: 'core.shiftblocks',
    SCHEDULE: 'core.schedule',
    SECURITY: 'core.security',
    TRADE_SHIFTS: 'core.trade-shifts',
    USERS: 'core.users',
};
exports.MILESTONES = {
    CREATE_COMPANY: 'CREATE_COMPANY',
    CREATE_EMPLOYEE: 'CREATE_EMPLOYEE',
    INVITE_EMPLOYEE: 'INVITE_EMPLOYEE',
    PUBLISH_SCHEDULE: 'PUBLISH_SCHEDULE',
    CREATE_DEVICE: 'CREATE_DEVICE',
    CREATE_ATTENDANCE: 'CREATE_ATTENDANCE',
};
exports.SCHEDULE_MILESTONES = [
    exports.MILESTONES.CREATE_COMPANY,
    exports.MILESTONES.CREATE_EMPLOYEE,
    exports.MILESTONES.INVITE_EMPLOYEE,
    exports.MILESTONES.PUBLISH_SCHEDULE,
];
exports.RCP_MILESTONES = [
    exports.MILESTONES.CREATE_COMPANY,
    exports.MILESTONES.CREATE_EMPLOYEE,
    exports.MILESTONES.CREATE_DEVICE,
    exports.MILESTONES.CREATE_ATTENDANCE,
];
exports.SCHEDULE_AND_RCP_MILESTONES = [
    exports.MILESTONES.CREATE_COMPANY,
    exports.MILESTONES.CREATE_EMPLOYEE,
    exports.MILESTONES.INVITE_EMPLOYEE,
    exports.MILESTONES.PUBLISH_SCHEDULE,
    exports.MILESTONES.CREATE_DEVICE,
    exports.MILESTONES.CREATE_ATTENDANCE,
];
exports.MILESTONES_GROUP = {
    SCHEDULE: exports.SCHEDULE_MILESTONES,
    RCP: exports.RCP_MILESTONES,
};
exports.QUEUES = {
    ABSENCE_WORKER: {
        ABSENCES: 'absences',
    },
    COMPANY_WORKER: {
        MAIN: 'companies-worker',
    },
    USER_WORKER: {
        EMPLOYMENT_CONDITIONS: 'employment-conditions',
        INTERNAL: {
            USERS: 'internal.user-service',
        },
    },
    WEATHER_WORKER: 'weather',
    GA_INTEGRATION: {
        INTERNAL: {
            LEAD_SOURCES: 'internal.ga.leadSources',
        },
    },
    ATTENDANCE_WORKER: {
        ATTENDANCE: 'attendance',
    },
    SCHEDULE_ADDONS_WORKER: {
        SCHEDULE_ADDONS: 'schedule-addons',
    },
    PAYROLL_WORKER: {
        MAIN: 'payroll-worker',
    },
    OVERTIME_WORKER: {
        OVERTIME_V2: 'overtimeV2',
    },
};
exports.BROADCASTS = {
    ABSENCE: {
        CREATE: 'broadcasts.absence.create',
        REJECT: 'broadcasts.absence.reject',
        CANCEL: 'broadcasts.absence.cancel',
        DELETE: 'broadcasts.absence.delete',
        ACCEPT: 'broadcasts.absence.accept',
    },
    ABSENCE_LIMIT: {
        UPDATE: 'broadcasts.absence_limit.update',
    },
    ABSENCE_TYPE: {
        CREATE: 'broadcasts.absence_type.create',
        UPDATE: 'broadcasts.absence_type.update',
        DELETE: 'broadcasts.absence_type.delete',
    },
    ATTENDANCE: {
        CREATE: 'broadcasts.attendance.create',
        EDIT: 'broadcasts.attendance.edit',
        DELETE: 'broadcasts.attendance.delete',
        OPEN: 'broadcasts.attendance.open',
        CLOSE: 'broadcasts.attendance.close',
        ASSIGN_LABELS: 'broadcasts.attendance.assign_labels',
        UNASSIGN_LABELS: 'broadcasts.attendance.unassign_labels',
    },
    CLIENT: {
        CHANGE_STATUS: 'broadcasts.client.change_status',
        UPDATE_BILLING: 'broadcasts.client.update_billing',
    },
    COMPANY: {
        CREATE: 'broadcasts.company.create',
        UPDATE_INTERNAL: 'broadcasts.company.update_internal',
    },
    DEVICE: {
        CREATE: 'broadcasts.device.create',
    },
    EMPLOYEE: {
        CREATE: 'broadcasts.employee.create',
        DELETE: 'broadcasts.employee.delete',
        INVITE: 'broadcasts.employee.invite',
        RESTORE: 'broadcasts.employee.restore',
        UPDATE: 'broadcasts.employee.update',
        UPDATE_INTERNAL: 'broadcasts.employee.update_internal',
    },
    EMPLOYMENT_CONDITIONS: {
        UPDATE: 'broadcasts.employment_conditions.update',
    },
    JOB_TITLE: {
        CREATE: 'broadcasts.job_title.create',
        DELETE: 'broadcasts.job_title.delete',
        UPDATE: 'broadcasts.job_title.update',
    },
    LIMIT_TEMPLATE: {
        UPDATE: 'broadcasts.limit_template.update',
    },
    LOCATION: {
        CREATE: 'broadcasts.location.create',
        DELETE: 'broadcasts.location.delete',
        RESTORE: 'broadcasts.location.restore',
        UPDATE: 'broadcasts.location.update',
    },
    LOCATION_SETTINGS: {
        EDIT: 'broadcasts.locationSettings.edit',
    },
    SCHEDULE: {
        PUBLISH: 'broadcasts.schedule.publish',
    },
    SHIFTS: {
        CREATE: 'broadcasts.shifts.create',
        EDIT: 'broadcasts.shifts.edit',
        DELETE: 'broadcasts.shifts.delete',
        PUBLISH: 'broadcasts.shifts.publish',
    },
    OWNER: {
        CREATE: 'broadcasts.owner.create',
    },
    REST_BREAK: {
        CREATE: 'broadcasts.rest_break.create',
        EDIT: 'broadcasts.rest_break.edit',
        DELETE: 'broadcasts.rest_break.delete',
    },
    AVAILABILITY: {
        CREATE: 'broadcasts.availability.create',
        EDIT: 'broadcasts.availability.edit',
        DELETE: 'broadcasts.availability.delete',
    },
    OVERTIME_COLLECTION: {
        CREATE: 'broadcasts.overtime_collection_create',
        DELETE: 'broadcasts.overtime_collection_delete',
    },
    OPEN_SHIFT: {
        CREATE: 'broadcasts.open_shift.create',
        EDIT: 'broadcasts.open_shift.edit',
        DELETE: 'broadcasts.open_shift.delete',
        APPLY: 'broadcasts.open_shift.apply',
        ASSIGN: 'broadcasts.open_shift.assign',
    },
    TRADE_SHIFT: {
        CREATE: 'broadcasts.trade_shift.create',
        EDIT: 'broadcasts.trade_shift.edit',
        DELETE: 'broadcasts.trade_shift.delete',
        APPLY: 'broadcasts.trade_shift.apply',
        ASSIGN: 'broadcasts.trade_shift.assign',
    },
};
var UserRoles;
(function (UserRoles) {
    UserRoles["MANAGER"] = "ROLE_MANAGER";
    UserRoles["OWNER"] = "ROLE_OWNER";
    UserRoles["EMPLOYEE"] = "ROLE_EMPLOYEE";
    UserRoles["LOCATION"] = "ROLE_LOCATION";
})(UserRoles = exports.UserRoles || (exports.UserRoles = {}));
